export enum AppointmentsSteps {
  STEP_1_CHOOSE_PATIENT = 'choose-patient',
  STEP_2_SCHEDULING_ITEMS = 'scheduling-items',
  STEP_3_ADDITIONAL_INFORMATION = 'additional-information',
  STEP_4_QUIZ = 'quiz',
  STEP_5_LOCATION = 'location',
  STEP_6_SCHEDULE_PERIOD = 'schedule-period',
  STEP_7_SUGGESTION = 'suggestion',
  STEP_8_SUGGESTION_SUMMARY = 'suggestion-summary',
  STEP_DOCUMENTS = 'step-upload-documents'
}

export enum AppointmentType {
  CHEMOTHERAPIES = 'chemotherapies',
  CONSULTATION = 'consultation',
  CONSULTATIONS = 'consultations',
  EXAMS = 'exams',
  NEW_APPOITMENT = 'new-appointment',
  SERVICES = 'services',
  SURGERIES = 'surgeries',
  REQUEST = 'request',
  RESCHEDULE = 'reschedule',
  WAITING_LIST = 'waitinglist',
  UNKNOW = ''
}

export enum ScheduleType {
  CONSULTATION = 'C',
  EXAM = 'E',
  SERVICE = 'S',
  SURGERY = 'Y',
  CHEMOTHERAPY = 'Q',
  REQUEST = 'R',
  WAITING_LIST = 'W',
  UNKNOW = ''
}

export enum ScheduleExpressionType {
  CONSULTATION = 'schedule-type.consultation',
  EXAM = 'schedule-type.exam',
  SERVICE = 'schedule-type.service'
}

export enum ScheduleAvailableType {
  HIBRID = 'H',
  READ_ONLY = 'V',
  REQUEST = 'R',
  WAITING_LIST = 'W'
}

export enum SchedulePeriodType {
  EVENING = 'A',
  MORNING = 'M',
  NIGHT = 'E'
}

export enum TeleconsultationType {
  TELECONSULTATION = 'S',
  IN_PERSON = 'N'
}

export enum AppointmentsIcons {
  CONSULTATION = '/static/assets/avatars/consultation.svg',
  EXAM = '/static/assets/avatars/exams.svg',
  SERVICE = '/static/assets/avatars/service.svg'
}

export enum VISIBILITY_OF_FIELD {
  NOT_SHOW = 'N',
  SHOW = 'V',
  REQUIRED = 'O'
}

export enum REQUIREMENT_FIELDS {
  LOCATION_REQUIRED = 'isLocationRequired',
  LOCATION_STEP_DONE = 'isLocationStepDone',
}

export const YES = 'S';

export const NO = 'N';

export const READ_ONLY = 'S';

export enum CUSTOM_MESSAGE_ACTION {
  UPLOAD_SCHEDULING_ACTION = 'US'
}
